<template>
  <div class="passcard-banner" 
       data-sensors-exposure-event-name="Element_Exposure"
       data-sensors-exposure-property-caseId="pass"
       @click="toDetail(contentTipText)"
       :style="`background-image:url(${info.backgroundImgUrl})`"
  >
    <div class="top">
      <!-- <img src="./images/icon_rmb.png" class="icon-rmb">
      <div class="text-small text-dark">优质资方·放款匹配<span class="text-red"> 98%</span></div> -->
    </div>
    <div class="content">
      <div class="left text-huge text-red">{{ info.passLimitAmount || 0 }}<span class="text-mini">元</span></div>
      <!-- <div class="center">
        <div class="text-small text-white">恭喜，您有一笔免审额度</div>
        <div class="text-large text-white">{{ contentTipText }}</div>
      </div>
      <img :src="contentTrailingIcon" class="right trailingIcon"> -->
    </div>
  </div>
</template>

<script>
import withdarwIcon from './images/icon_withdraw.png'
import getIcon from './images/icon_get.png'

export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    contentTrailingIcon () {
      if (this.info.passCardTag === 'HAVE_QUALIFICATION') {
        return withdarwIcon
      } else if (this.info.passCardTag === 'HAVE_EFFECTIVE_LIMIT') {
        return getIcon
      }
    },
    contentTipText () {
      if (this.info.passCardTag === 'HAVE_QUALIFICATION') {
        return '待提现'
      } else if (this.info.passCardTag === 'HAVE_EFFECTIVE_LIMIT') {
        return '待领取'
      }
    }
  },
  methods: {
    toDetail (contentTipText) {
      this.$sensors.track('Withdraw_Element_Click', { msg_name: contentTipText })
      this.$router.push('/middle/limit')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";


@keyframes scale {
  0% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(1.0);
  }
  100% {
    transform: scale(1.1);
  }
}

.trailingIcon {
  animation: scale 1s linear infinite;
}

.text-red {
  color: #FF4633;
}

.text-dark {
  color: #333333;
}

.text-white {
  color: #fff
}

.text-mini {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
}

.text-small {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
}

.text-large {
  font-size: 37px;
  font-family: PingFangSC-Medium, PingFang SC;
}

.text-huge {
  font-size: 50px;
  font-family: DIN-Medium, DIN;
  font-weight: 500;
  color: #FF4633;
  line-height: 61px;
}

.passcard-banner {
  width: 670px;
  height: 200px;
  // background: linear-gradient(360deg, #D7E0FA 0%, #E9EFFC 100%);
  box-shadow: 0px 20px 20px 0px rgba(231,231,231,0.5);
  background-size: 100% 100%;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  .top {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .icon-rmb {
      width: 28px;
      height: 28px;
      margin-right: 8px;
    }
  }
  .content {
    // background: url(./images/img_card.png) center no-repeat no-repeat;
    // background-size: cover;
    width: 630px;
    height: 118px;
    display: flex;
    // flex-direction: row;
    // justify-content: space-between;
    align-items: center;
    padding: 16px 15px 16px 34px;
    .left {
      flex: 0.7;
      padding-top: 10px;
    
      // text-align: center;
    }
    .center {
      margin-left: 70px;
      flex: 1.5;
    }
    .right {
      flex: 0.3;
    }
  }
}

</style>